import { render, staticRenderFns } from "./SalesOverview.vue?vue&type=template&id=68ed62d8&scoped=true"
import script from "./SalesOverview.vue?vue&type=script&lang=js"
export * from "./SalesOverview.vue?vue&type=script&lang=js"
import style0 from "./SalesOverview.vue?vue&type=style&index=0&id=68ed62d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ed62d8",
  null
  
)

export default component.exports